import { Icons, Stack, TagChip, type StackProps } from '@munifocus/ui';
import { useTranslation } from 'react-i18next';

/**
 * A file's officer-applied tags, as factual labels. Tags are added and removed
 * from the file list's bulk actions; here they are only read.
 */
export function FileTags({ tags, sx }: { tags: readonly string[]; sx?: StackProps['sx'] }) {
  const { t } = useTranslation();
  if (!tags.length) return null;
  return (
    <Stack
      direction="row"
      spacing={0.5}
      useFlexGap
      aria-label={t('gov.tags.label')}
      sx={{ flexWrap: 'wrap', ...((sx as object) ?? {}) }}
    >
      {tags.map((tag) => (
        <TagChip key={tag} label={tag} icon={Icons.Tag} />
      ))}
    </Stack>
  );
}
